import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Popconfirm } from "antd";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { Notices } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../store/stores.js";
import { __, _i } from "../../utils/i18n.js";
const NoticeBannerlessConsent = observer(()=>{
    const { optionStore, cookieStore } = useStores();
    const { bannerlessConsentChecks: { legalBasisLegitimateInterest, legalBasisConsentWithoutVisualContentBlocker }, isBannerLessConsent } = optionStore;
    const { pathname } = useLocation();
    return /*#__PURE__*/ _jsx(Notices, {
        notices: [
            {
                nop: true,
                key: "bannerless-consent-legitimate-interest",
                message: isBannerLessConsent && pathname.indexOf("/edit/") === -1 && pathname.indexOf("/new") === -1 && legalBasisLegitimateInterest.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: __("You have decided to obtain consent without cookie banners (banner-less consent) on your website. This means that when your website visitors visit your website for the first time, they will not know that you use this service on the basis of a legitimate interest and can object to it. They will need to read your cookie policy or privacy policy to find out.")
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: __("At the same time, you use the following non-essential services on the legal basis of a legitimate interest:")
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            children: legalBasisLegitimateInterest.map(({ name, groupId, id })=>/*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: name
                                        }),
                                        "\xa0•\xa0",
                                        /*#__PURE__*/ _jsx("a", {
                                            href: `#/cookies/${groupId}/edit/${id}`,
                                            children: __("Edit")
                                        })
                                    ]
                                }, id))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: _i(__("Check whether there really is a legitimate interest in the legal sense according to {{a}}Art. 6 (1) (f) GDPR{{/a}}, which is only given in rare cases!"), {
                                a: /*#__PURE__*/ _jsx("a", {
                                    href: "https://gdpr-text.com/read/article-6/",
                                    target: "_blank",
                                    rel: "noreferrer"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx("a", {
                                onClick: ()=>optionStore.dismissBannerlessConsentLegitimateServicesNotice(),
                                children: __("Dismiss notice")
                            })
                        })
                    ]
                }),
                severity: "warning"
            },
            {
                nop: true,
                key: "bannerless-consent-services-without-visual-content-blocker",
                message: isBannerLessConsent && pathname.indexOf("/edit/") === -1 && pathname.indexOf("/new") === -1 && legalBasisConsentWithoutVisualContentBlocker.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: __("You have decided to obtain consent without cookie banners (banner-less consent) on your website. At the same time, some non-essential services, which requires a consent, doese not have visual content blockers, which is why website visitors without cookie banners cannot consent to them (except via the legal link to change the privacy settings).")
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: __("You should create visual content blockers for these services, if the services display visual elements, or disable them for your website! The following services are affected:")
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            children: legalBasisConsentWithoutVisualContentBlocker.map(({ name, groupId, id })=>/*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: name
                                        }),
                                        "\xa0•\xa0",
                                        /*#__PURE__*/ _jsx("a", {
                                            href: `#/blocker/new`,
                                            children: __("Create Content Blocker")
                                        }),
                                        "\xa0•\xa0",
                                        /*#__PURE__*/ _jsx(Popconfirm, {
                                            title: __("Are you sure you want to disable this service?"),
                                            onConfirm: async ()=>{
                                                const group = cookieStore.groups.entries.get(groupId);
                                                await group.fetchCookies();
                                                const cookie = group.cookies.entries.get(id);
                                                cookie.setStatus("private");
                                                return cookie.patch();
                                            },
                                            okText: __("Deactivate"),
                                            cancelText: __("Cancel"),
                                            children: /*#__PURE__*/ _jsx("a", {
                                                children: __("Disable")
                                            })
                                        })
                                    ]
                                }, id))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx("a", {
                                onClick: ()=>optionStore.dismissBannerlessConsentServicesWithoutVisualContentBlockerNotice(),
                                children: __("Dismiss notice")
                            })
                        })
                    ]
                }),
                severity: "warning"
            }
        ]
    });
});
export { NoticeBannerlessConsent };
